import logo from '../Assets/Imgs/logos/Zeroz-Logo-Horizontal-Black.png';

import NavBar from '../Components/NavBar';
import Footer from '../Components/Footer';
import SongCard from '../Components/SongCard';

import buy from '../Assets/Imgs/Icons/ticket-icon.png';

import tourPoster1 from '../Assets/Imgs/tourPosters/tour1.png';
import tourPoster2 from '../Assets/Imgs/tourPosters/tour2.png';
import tourPoster3 from '../Assets/Imgs/tourPosters/tour3.png';
import tourPoster4 from '../Assets/Imgs/tourPosters/tour4.png';
import tourPoster5 from '../Assets/Imgs/tourPosters/tour5.png';

function Tickets() {

  const ticketsInfo = [
    {
      eventName: "Fire Noise",
      venue:"Osaka Fireloop",
      description:"",
      posterImg:tourPoster1,
      date:'11月11日',
      cost:'ADV¥2,500 / DOOR¥3,000',
      acts:[],
      link:'https://forms.gle/P53fNEKwpHck45oi6',
    },
    {
      eventName: "Full Heal - Noise",
      venue:"Shimokitazawa THREE",
      description:"",
      posterImg:tourPoster2,
      date:'11月12日',
      cost:'¥3,000 (1 drink included)',
      acts:[],
      link:'https://forms.gle/y6AE2S88RmtYxDiS6',
    },
    {
      eventName: "Ever Green Noise",
      venue:"Sendai BIRDLAND",
      description:"",
      posterImg:tourPoster3,
      date:'11月13日',
      cost:'¥3,000 (1 drink included)',
      acts:[],
      link:'https://forms.gle/Lv8maumkZV9XsJBe6 ',
    },
    {
      eventName: "Morning Noise Love",
      venue:"Shimokitazawa SPREAD",
      description:"",
      posterImg:tourPoster4,
      date:'11月14日',
      cost:'ADV¥2,500 / DOOR¥3,000 (+1 drink)',
      acts:[],
      link:'https://livepocket.jp/e/morning_noise_love',
    },
    {
      eventName: "X-SHINE",
      venue:"Shibuya X-Farm x MOONSHINE",
      description:"",
      posterImg:tourPoster5,
      date:'11月15日',
      cost:'¥1,500 (+1 drink)',
      acts:[],
      link:'',
    }
  ];

  const posterEnlarge = (poster) => {
    var posterImg = poster.target.cloneNode(true);
    var posterDiv = document.createElement('div');
    var posterExit = document.createElement('p');
    
    posterDiv.classList.add('sticky-Img-Overlay');

    posterExit.textContent='X';

    posterDiv.append(posterExit)
    posterDiv.append(posterImg)

    document.querySelector('.App').append(posterDiv);

    posterExit.addEventListener("click", () => {posterDiv.remove()});
  }
  
  const renderTicketList = () => {
    const ticketsRendered = ticketsInfo.map((show, index) => {
      return (
        <div className="row ticket-show-row" key={index}>
          <div className="cardSongClassic" >
            <div className="img" >
              <img src={show.posterImg} onClick={posterEnlarge} className="tickets-show-poster" alt="show-cover" /> 
            </div>
          </div>
          <div className="column cardSongLinkColumn center-mobile">
            <div className="row full spaceAround">
              <h2>{show.eventName}</h2>
              <h2>{show.venue}</h2>
            </div>
            <div className="row full spaceAround">
              <p>{show.date}</p>
              <p>{show.cost}</p>
              {show.link.length > 0 &&
                <a className="cardSongLinkClassic center" href={show.link}>
                  <img src={buy} alt="buy" id={"img0" + (index + 1)} className="icon music-player-icon" />
                  <p>tickets</p>
                </a>
              }
            </div>
          </div>
        </div>
      )
    })

    return ticketsRendered
  }

  return (
    <div className="App">
      <NavBar />
      <div className="App-header tickets-bg headerGrowing">
        <div className="blurScreen" />
        
        <div className="tickets-header gameHeaderShade">
          <div className="blockWhite" style={{padding:'3%', marginTop:'5rem'}}>
            <h2>Noise Star が11月に日本でライブを行う!</h2>
          </div>
        </div>

        <div className="column center full" style={{zIndex:1}}>
          {renderTicketList()}
        </div>

      </div>

      <Footer />
    </div>
  );
}

export default Tickets;
